const ICONS = {
    success: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>`,
    error: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>`,
    info: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>`,
};
function injectStyles() {
    if (document.getElementById('toast-styles'))
        return;
    const style = document.createElement('style');
    style.id = 'toast-styles';
    style.textContent = `
    #toast-container {
      position: fixed;
      bottom: 24px;
      right: 24px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      z-index: var(--z-toast, 200);
      pointer-events: none;
    }

    .toast {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 16px;
      background: var(--color-surface-2, #161616);
      border: 1px solid var(--color-border, #2a2a2a);
      border-radius: var(--radius-md, 12px);
      box-shadow: var(--shadow-lg, 0 8px 32px rgba(0,0,0,0.6));
      font-size: 0.875rem;
      font-weight: 500;
      max-width: 360px;
      pointer-events: all;
      animation: toast-in 200ms ease forwards;
      transition: opacity 200ms ease, transform 200ms ease;
    }

    .toast.leaving {
      animation: toast-out 200ms ease forwards;
    }

    .toast-success { color: var(--color-accent, #34f5c5); border-color: rgba(52,245,197,0.2); }
    .toast-error   { color: var(--color-danger, #ff4757); border-color: rgba(255,71,87,0.2); }
    .toast-info    { color: var(--color-text, #f0f0f0); }

    @keyframes toast-in {
      from { opacity: 0; transform: translateY(12px) scale(0.96); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }

    @keyframes toast-out {
      from { opacity: 1; transform: translateY(0) scale(1); }
      to   { opacity: 0; transform: translateY(12px) scale(0.96); }
    }
  `;
    document.head.appendChild(style);
}
export function showToast({ message, type = 'info', duration = 3500, }) {
    injectStyles();
    const container = document.getElementById('toast-container');
    if (!container)
        return;
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.innerHTML = `${ICONS[type]}<span>${message}</span>`;
    container.appendChild(toast);
    const remove = () => {
        toast.classList.add('leaving');
        toast.addEventListener('animationend', () => toast.remove(), { once: true });
    };
    setTimeout(remove, duration);
}
